module.exports = __webpack_public_path__ + "img/copy.4d3abf10.svg";